const AssetLoadProgress = ({ current, total }) => {
  if (current >= total) {
    return null;
  }

  return (
    <div className="w-full m-auto text-center">
      Loading Assets {current} of {total}
    </div>
  );
};

export default AssetLoadProgress;
